import Tibbit40_1Node from '@appblocks/codegeneration/Nodes/Tibbit40_1Node';
import { Setting, SettingType } from '@appblocks/codegeneration/types';
import Tibbit40Node from '@appblocks/codegeneration/Nodes/Tibbit40Node';

export default class Tibbit40_4Node extends Tibbit40Node {
    constructor() {
        super();
        this.name = 'Tibbit 40_4';
        this.id = 'node_tibbit_40_4';
        this.linkedFeature = 'tibbit_40_4';
        this.description = 'Digital potentiometer, 100KOhm';
        this.range = 100000;

        const settings: Setting[] = [
            {
                id: 'TIBBIT',
                name: 'Tibbit',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'tibbit_40_4',
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }
}
